module.exports = __webpack_public_path__ + "img/Rectangle 18.0cbaf1cb.png";